import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

const CLEAR_VERSION_HISTORY = 'forms/versionHistory/CLEAR_VERSION_HISTORY'
const GET_VERSION_HISTORY = 'forms/versionHistory/GET_VERSION_HISTORY'
const GET_VERSION_HISTORY_SUCCESS = 'forms/versionHistory/GET_VERSION_HISTORY_SUCCESS'
const GET_VERSION_HISTORY_FAIL = 'forms/versionHistory/GET_VERSION_HISTORY_FAIL'

export const actions = {
  CLEAR_VERSION_HISTORY,
  GET_VERSION_HISTORY,
  GET_VERSION_HISTORY_SUCCESS,
  GET_VERSION_HISTORY_FAIL
}

export const initialState = {
  error: null,
  id: null,
  versions: [],
  loading: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VERSION_HISTORY:
      return {
        ...initialState
      }
    case GET_VERSION_HISTORY:
      return {
        ...state,
        id: action.uuid,
        loading: true
      }
    case GET_VERSION_HISTORY_SUCCESS:
      return {
        ...state,
        id: action.payload.id,
        versions: action.payload.versions,
        loading: false
      }
    case GET_VERSION_HISTORY_FAIL:
      return {
        ...state,
        error: 'There was an error loading data, please try again',
        loading: false
      }
    default:
      return state
  }
}

export default reducer

export function clearVersionHistory() {
  return {
    type: CLEAR_VERSION_HISTORY
  }
}

export function getVersionHistory({ uuid }) {
  return {
    type: CALL_API,
    types: [GET_VERSION_HISTORY, GET_VERSION_HISTORY_SUCCESS, GET_VERSION_HISTORY_FAIL],
    callAPI: () => axios.get(`/forms/${uuid}/history`, { ...fetchOptions('v2') })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/versionHistory.js